import { render } from "./leaderHallEdit.vue?vue&type=template&id=6a8bac94&scoped=true"
import script from "./leaderHallEdit.vue?vue&type=script&lang=js"
export * from "./leaderHallEdit.vue?vue&type=script&lang=js"

import "./leaderHallEdit.vue?vue&type=style&index=0&id=6a8bac94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8bac94"]])

export default __exports__